/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  // CREATE_INSTRUCTIONS,
  // CREATE_INSTRUCTIONS_SUCCESS,
  // CREATE_INSTRUCTIONS_ERROR,
  ADD_EQUIPMENT_SCHEDULING,
  ADD_EQUIPMENT_SCHEDULING_SUCCESS,
  ADD_EQUIPMENT_SCHEDULING_ERROR,
  LOAD_EQUIPMENT_SCHEDULING,
  LOAD_EQUIPMENT_SCHEDULING_SUCCESS,
  LOAD_EQUIPMENT_SCHEDULING_ERROR,
  UPDATE_EQUIPMENT_SCHEDULING,
  UPDATE_EQUIPMENT_SCHEDULING_SUCCESS,
  UPDATE_EQUIPMENT_SCHEDULING_ERROR,

  EQUIPMENT_VACANCY_LIST,
  EQUIPMENT_VACANCY_LIST_SUCCESS,
  EQUIPMENT_VACANCY_LIST_ERROR,
  
  EQUIPMENT_OFFICE_VACANCY_LIST,
  EQUIPMENT_OFFICE_VACANCY_LIST_SUCCESS,
  EQUIPMENT_OFFICE_VACANCY_LIST_ERROR,

  EQUIPMENT_FINAL_COMMIT,
  EQUIPMENT_FINAL_COMMIT_SUCCESS,
  EQUIPMENT_FINAL_COMMIT_ERROR,
} from "./constants"

//Special Instructions
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData, success) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
    success,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function loadEquipmentScheduling(record) {
  return {
    type: LOAD_EQUIPMENT_SCHEDULING,
    record,
  }
}

export function loadEquipmentSchedulingSuccess(equipment_scheduling, success) {
  return {
    type: LOAD_EQUIPMENT_SCHEDULING_SUCCESS,
    equipment_scheduling,
    success,
  }
}

/**
 * @param {string} error
 */

export function loadEquipmentSchedulingError(error) {
  return {
    type: LOAD_EQUIPMENT_SCHEDULING_ERROR,
    error,
  }
}

export function addEquipmentDetails(equipmentDetails) {
  console.log("record", equipmentDetails)
  return {
    type: ADD_EQUIPMENT_SCHEDULING,
    equipmentDetails,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function addEquipmentDetailsSuccess(equipmentDetails, success) {
  console.log("record", equipmentDetails)
  return {
    type: ADD_EQUIPMENT_SCHEDULING_SUCCESS,
    equipmentDetails,
    success,
  }
}

/**
 * @param {string} error
 */
export function addEquipmentDetailsError(error) {
  return {
    type: ADD_EQUIPMENT_SCHEDULING_ERROR,
    error,
  }
}

export function updateEquipmentDetails(equipmentDetails) {
  return {
    type: UPDATE_EQUIPMENT_SCHEDULING,
    equipmentDetails,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateEquipmentDetailsSuccess(equipmentDetails, success) {
  return {
    type: UPDATE_EQUIPMENT_SCHEDULING_SUCCESS,
    equipmentDetails,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateEquipmentDetailsError(error) {
  return {
    type: UPDATE_EQUIPMENT_SCHEDULING_ERROR,
    error,
  }
}

export function loadEquipmentVacancy(record) {
  return {
    type: EQUIPMENT_VACANCY_LIST,
    record,
  }
}

export function loadEquipmentVacancySuccess(equipment_vacancy_details) {
  return {
    type: EQUIPMENT_VACANCY_LIST_SUCCESS,
    equipment_vacancy_details,
  }
}

/**
 * @param {string} error
 */

export function loadEquipmentVacancyError(error) {
  return {
    type: EQUIPMENT_VACANCY_LIST_ERROR,
    error,
  }
}

export function loadEquipmentOfficeVacancy(record) {
  return {
    type: EQUIPMENT_OFFICE_VACANCY_LIST,
    record,
  }
}

export function loadEquipmentOfficeVacancySuccess(equipment_office_details) {
  return {
    type: EQUIPMENT_OFFICE_VACANCY_LIST_SUCCESS,
    equipment_office_details,
  }
}

/**
 * @param {string} error
 */

export function loadEquipmentOfficeVacancyError(error) {
  return {
    type: EQUIPMENT_OFFICE_VACANCY_LIST_ERROR,
    error,
  }
}

export function equipmentFinalCommit(equipmentCommit) {
  console.log("record", equipmentCommit)
  return {
    type: EQUIPMENT_FINAL_COMMIT,
    equipmentCommit,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function equipmentFinalCommitSuccess(equipmentCommit, success) {
  console.log("record", equipmentCommit)
  return {
    type: EQUIPMENT_FINAL_COMMIT_SUCCESS,
    equipmentCommit,
    success,
  }
}

/**
 * @param {string} error
 */
export function equipmentFinalCommitError(error) {
  return {
    type: EQUIPMENT_FINAL_COMMIT_ERROR,
    error,
  }
}

const actions = {
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  addEquipmentDetails,
  addEquipmentDetailsError,
  addEquipmentDetailsSuccess,

  equipmentFinalCommit,
  equipmentFinalCommitSuccess,
  equipmentFinalCommitError,

  updateEquipmentDetailsError,
  updateEquipmentDetails,
  updateEquipmentDetailsSuccess,

  loadEquipmentScheduling,
  loadEquipmentSchedulingSuccess,
  loadEquipmentSchedulingError,

  loadEquipmentVacancy,
  loadEquipmentVacancySuccess,
  loadEquipmentVacancyError,

  loadEquipmentOfficeVacancy, 
  loadEquipmentOfficeVacancySuccess, 
  loadEquipmentOfficeVacancyError, 
}

export default actions
